app.controller('popupHeartEchoController', ['$scope', '$rootScope', '$state', '$mdDialog', 'visitCardData', 'heartEchoModel',
    function ($scope, $rootScope, $state, $mdDialog, visitCardData, heartEchoModel) {

        function setData() {
            $scope.heartEchoData = new HeartEchoVO();
            $scope.heartEchoForm = null;

            $scope.heartEchoData.visitCard = {
                id: visitCardData.visitCard.id
            };

            $scope.heartEchoData.mitralValveExaminationDetails = null;
            $scope.heartEchoData.aorticValveExaminationDetails = null;
            $scope.heartEchoData.tricuspidValveExaminationDetails = null;
            $scope.heartEchoData.pulmonaryValveExaminationDetails = null;
            $scope.heartEchoData.contractilityDetails = null;
            $scope.heartEchoData.pericardialDetails = null;

            $scope.bloodCorrectOption = [{value: 'BLOOD_COUNT_CORRECT', label: 'Morfologia prawidłowa'}];
            $scope.contractilityCorrectOption = [{value: 'NO_CONTRACTILITY_DISORDER', label: 'Bez zaburzeń kurczliwości'}];
            $scope.pericardialCorrectOption = [{value: 'NO_PERICARDIAL_EFFUSSION', label: 'Morfologia prawidłowa'}];

            $scope.descInputPlaceholder = 'Do 500 znaków';

            $scope.checkbox = {
                other: false,
                conclude: false
            };

            $scope.formFirstCheck = false;
        }

        function setPermissions() {
        }

        function setListeners() {
            $scope.$on(Event.HEART_ECHO.SAVE.SUCCESS, function(event, data) {
                $scope.cancel();
                setTimeout(function() {
                    $rootScope.$broadcast(Event.NOTIFICATION, new NotificationVO(Enum.NOTIFICATION_TYPE.SUCCESS, 'T.MEEDY.SYSTEM.NOTIFICATION.OPERATION_SUCCEEDED'));
                }, 500);
            });

        }

        function setActions() {
            $scope.cancel = function() {
                $mdDialog.cancel();
            };

            $scope.save = function () {
                $scope.heartEchoForm.$setSubmitted();
                if ($scope.heartEchoForm.$valid || $scope.formFirstCheck) {
                    heartEchoModel.save($scope.heartEchoData);
                } else {
                    $scope.formFirstCheck = true;
                }
            };

        }

        function configureInterface() {

        }

        function initialize() {
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
